import { captureAction } from '@smg-real-estate/browser-rum';

const ACTION_NAME = '[Vue warn]: Hydration';

const isDatadogEnabled = (): boolean =>
  typeof window !== 'undefined' && ['test', 'prod'].includes(import.meta.env.VUE_APP_ENVIRONMENT);

export const interceptHydrationWarnings = (): (() => void) => {
  if (!isDatadogEnabled()) return () => {};

  const origWarn = console.warn;
  console.warn = (...args: unknown[]) => {
    origWarn.apply(console, args);
    const msg = args.map(String).join(' ');
    if (msg.startsWith('[Vue warn]: Hydration')) {
      captureAction(ACTION_NAME, {
        detail: msg,
        url: window.location.href,
      });
    }
  };

  return () => {
    console.warn = origWarn;
  };
};
